// Color classes based on category
export const colorClasses = {
  blue: {
    bg: 'bg-blue-50/50',
    border: 'border-blue-200',
    dot: 'bg-blue-500',
    text: 'text-blue-700',
  },
  green: {
    bg: 'bg-green-50/50',
    border: 'border-green-200',
    dot: 'bg-green-500',
    text: 'text-green-700',
  },
  indigo: {
    bg: 'bg-indigo-50/50',
    border: 'border-indigo-200',
    dot: 'bg-indigo-500',
    text: 'text-indigo-700',
  },
  yellow: {
    bg: 'bg-yellow-50/50',
    border: 'border-yellow-200',
    dot: 'bg-yellow-500',
    text: 'text-yellow-700',
  },
  purple: {
    bg: 'bg-purple-50/50',
    border: 'border-purple-200',
    dot: 'bg-purple-500',
    text: 'text-purple-700',
  },
  emerald: {
    bg: 'bg-emerald-50/50',
    border: 'border-emerald-200',
    dot: 'bg-emerald-500',
    text: 'text-emerald-700',
  },
  teal: {
    bg: 'bg-teal-50/50',
    border: 'border-teal-200',
    dot: 'bg-teal-500',
    text: 'text-teal-700',
  },
  gray: {
    bg: 'bg-gray-50/50',
    border: 'border-gray-200',
    dot: 'bg-gray-500',
    text: 'text-gray-700',
  },
};

